import axiosInstance from '@/services/axiosInstance'

async function setup (membership, code, cardId, price, okUrl, koUrl) {
  const operationNumber = `${membership}|${code}|${cardId}|` + Date.now()
  const data = {
    operationNumber,
    price: toCents(price),
    urlOk: okUrl,
    urlKo: koUrl
  }
  const req = {
    url: '/payments/setup',
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data
}

function toCents (amount) {
  const str = amount.toString()
  const int = str.split('.')

  return int[0] + int[1].padEnd(2, '0').substring(0, 2)
}

export {
  setup
}
